/* datas */
import { GetBkgLogo } from '../Functions/GetBkgLogo.js';
import { GetYear } from '../Functions/GetDates.js';
/* document */
import { LogoCategories } from '../../../Files/LogoCategories.js';
import { LogoImgAttraction } from '../../../Files/LogoImgAttraction.js';
import { BlockLink } from '../Blocks/BlockLink.js';

export const BlockLogoCategories = (props) => {
    const label = props.label;
    const item = props.item;
    const legend = props.legend;
    let values, src, bkg;
    switch (label) {
        case 'categories':
            if (label === 'categories') {
                src = LogoCategories(item.cslug);
                values = [
                    { name: item.cname, route: item.croute },
                    { legend: legend[0] }, // attractions
                    { legend: legend[1] }, // rendez-vous
                    { legend: legend[2] }, // archives
                    { legend: item.cname === 'Archives' ? legend[3] : ''}, // all archives
                ];
            }
            return (
                <div className="logo">
                    <a className="icon" href={values[0].route} alt={values[0].name} title={values[0].name}>
                        <img className="img" src={src} title={values[0].name} alt={values[0].name} loading="lazy" />
                    </a>
                    <div className="legend">
                        <div className="title">{values[0].name}</div>
                        <div>{values[1].legend}</div>
                        <div>{values[2].legend}</div>
                        <div>{values[3].legend}</div>
                        <div>{values[4].legend}</div>
                    </div>
                </div>
            )
        case 'families':
            src = LogoCategories(item.fslug);
            values = [
                { name: item.fname, route: item.froute },
                { legend: legend[0] },
                { legend: legend[1] },
            ]
            return (
                <div className="logo">
                    <a className="icon" href={values[0].route} alt={values[0].name} title={values[0].name}>
                        <img className="img" src={src} title={values[0].name} alt={values[0].name} loading="lazy" />
                    </a>
                    <div className="legend">
                        <div className="title">{values[0].name}</div>
                        <div>{values[1].legend}</div>
                        <div>{values[2].legend}</div>
                    </div>
                </div>
            )

        case 'category':
            src = LogoImgAttraction('icon', item.cslug, item.aslug);
            bkg = GetBkgLogo(item.aroute);
            values = [
                { name: item.aname, route: item.aroute, created: GetYear(item.created) },
                { name: item.uname, href: item.uroute },
                { name: item.cname, href: item.croute },
            ];
            return (
                <div className={`logo ${bkg}`}>
                    <a className="icon" href={values[0].route} alt={values[0].name} title={values[0].name}>
                        <img className="img" src={src} title={values[0].name} alt={values[0].name} loading="lazy" />
                    </a>
                    <div className="legend">
                        <div className="title">{values[0].name}</div>
                        <div className="block-created">
                            <div className="created">{values[0].created}</div>
                        </div>
                        <BlockLink label="link-true" href={values[1].href} name={values[1].name} />
                        <BlockLink label="link-true" href={values[2].href} name={values[2].name} />
                    </div>
                </div>
            )
        default:
            return (<></>)
    }
}